// ===========================================================================
// CDCI — Clinical Documentation & Charge Intelligence
// Módulo Etapa 2 (docs/modulos/BillingV2/02_CDCI_Descripcion_Modulo.md).
// Acompaña al médico en el ciclo completo de la cita: agenda → contexto →
// nota → cargos → firma. AdvancedMD sigue siendo el source of truth.
//
// ACCESO: lo gobierna la matriz RBAC y NADA MÁS — módulo `cdci` (37) del
// catálogo, mapeado en app/AccessDenied/roleRoutePermissions.js.
//
// 2026-08-31: se retiró `CdciGuardedRoute`, que exigía ADEMÁS estar en la
// allowlist compartida del ciclo de visita (REACT_APP_PREVISIT_EMPLOYEES).
// Ese segundo gate hacía que conceder el módulo desde Access Control no
// alcanzara y el usuario cayera en /AccessDenied sin explicación. Mismo
// arreglo que Pre-Visit Planning, Patient Geography y el Transcriptor: hoy
// ningún módulo del ciclo de visita gatea por lista de empleados.
// ===========================================================================
import React, { lazy } from "react";
import { CDCI_BASE_PATH } from "./common/constants";

// Lazy: nada del módulo viaja en el bundle inicial.
// AppRouter ya provee el <Suspense> por ruta.
const CdciSchedulePage = lazy(() => import("./pages/CdciSchedulePage"));
const CdciEncounterPage = lazy(() => import("./pages/CdciEncounterPage"));

export const cdciRoutes = [
  { path: CDCI_BASE_PATH, element: <CdciSchedulePage /> },
  { path: `${CDCI_BASE_PATH}/encounter/:appointmentId`, element: <CdciEncounterPage /> },
];

export { CdciSchedulePage, CdciEncounterPage };
export { CDCI_BASE_PATH } from "./common/constants";
